import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IExamdate } from "../../../Pages/ExamDate/IExamDate";

export const EditExamdateSlice = createSlice({
  name: "EditExamdateSlice",
  initialState: {} as IReduxState<IExamdate>,
  reducers: {
    EditExamdate: (state, _: PayloadAction<IExamdate>) => {
      state.isLoading = true;
    },
    successEditExamdate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureEditExamdate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearEditExamdateResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  EditExamdate,
  failureEditExamdate,
  successEditExamdate,
  clearEditExamdateResponse,
} = EditExamdateSlice.actions;

export default EditExamdateSlice.reducer;
